
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M30.338 35.6V25.3c0-1.9-1.4-1.9-1.4 0v10.3c0 1.9 1.4 1.9 1.4 0zM28.938 41.3c0-.4.1-1.6.7-1.6.6.1.7 1.2.7 1.6V44c0 .4-.1 1.6-.7 1.6s-.7-1.2-.7-1.6v-2.7z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M52.938 48.9c-3.8-6.6-7.625-13.225-11.45-19.85v-.002C37.662 22.424 33.837 15.8 30.037 9.2c-.1-.2-.3-.2-.4-.2-.1 0-.2 0-.3.2-3.85 6.6-7.675 13.225-11.5 19.85-3.825 6.625-7.65 13.25-11.5 19.85-.3.5-.7 2.9.3 2.9h45.9c1.2.1.7-2.4.4-2.9zm-23.3-36.4c3.5 6.05 6.975 12.075 10.45 18.1 3.475 6.025 6.95 12.05 10.45 18.1h-41.8c7-12 14-24.1 20.9-36.2z"}})])
          )
        }
      }
    